module.exports = __webpack_public_path__ + "static/media/joshua-reddekopp-SyYmXSDnJ54-unsplash.39ee51e0.jpg";